import React from "react";
import ICatalog_Item from "../../../models/ICatalog_Item";
import OwLabel from "../../shared/OwLabel/OwLabel";

type Props = {
    kitCatalogItem: ICatalog_Item;
};

export const KitBasicListDetail: React.FC<Props> = (props) => {
    return (
        <div className={"KitBasicListDetail "}>
            <OwLabel title={"includes"} />
            <div className={"text-small"}>
                {(props.kitCatalogItem.Kit_Items_Map || []).map((mapItem) => {
                    return (
                        <div key={mapItem.guid}>
                            ({mapItem.qty_in_kit || 0}) {mapItem.Catalog_Item?.name}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
